<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <audio id="gasNotifier"></audio>
      <h3>{{ _('Fuel') }} <button class="btn btn-info" v-if="showAudioButton" v-on:click="audioButtonClicked"><i class="fa fa-fw fa-volume-up"></i></button></h3>
      <div v-if="status">
        <div class="table-container" role="table" :aria-label="_('Pumps')">
          <div class="flex-table header" role="rowgroup">
            <div class="flex-row first" role="columnheader">&nbsp;</div>
            <div class="flex-row" role="columnheader">{{ _('Status') }}</div>
            <div class="flex-row" role="columnheader">{{ _('Nozzle') }}</div>
            <div class="flex-row" role="columnheader">{{ _('Price') }}</div>
            <div class="flex-row" role="columnheader">{{ _('Litres') }}</div>
            <div class="flex-row" role="columnheader">{{ _('Total') }}</div>
            <div class="flex-row wide" role="columnheader">{{ _('Reserve sum') }}</div>
            <div class="flex-row wide" role="columnheader">&nbsp;</div>
            <div class="flex-row wide" role="columnheader">{{ _('Total') }}</div>
          </div>
          <div class="flex-table row" role="rowgroup" v-for="(pumpStatus, pumpIndex) in status.pumpStatus.pStat" v-show="isPumpVisible(pumpIndex + 1)">
            <div class="flex-row pump first" role="cell"><span class="hidden-sm hidden-xs">{{ _('Pump') }} </span><span class="visible-sm visible-xs">{{ _('Pump').charAt(0) }} </span>{{ getDisplayedIndex(pumpIndex) }}</div>
            <div :class="'flex-row pump-status pump-status-' + pumpStatus" role="cell">{{ getStatusText(pumpStatus, pumpIndex) }}</div>
            <div class="flex-row" role="cell">{{ status.pumpStatus.nameGas[pumpIndex] }}</div>
            <div class="flex-row" role="cell">{{ $filters.num(status.pumpStatus.prices[pumpIndex].price[status.pumpStatus.cNozzle[pumpIndex]] / 1000, 3) }}</div>
            <div class="flex-row" role="cell">{{ $filters.num(status.pumpStatus.litre[pumpIndex] / 100) }}</div>
            <div class="flex-row" role="cell">{{ total[pumpIndex] }}</div>
            <div class="flex-row wide" role="cell"><input type="text" class="form-control" v-model.number="reserve[pumpIndex]" /></div>
            <div class="flex-row buttons wide" role="cell"><a :class="'btn ' + getStartButtonClass(pumpIndex)" v-on:click="startFilling(pumpIndex)">{{ _('Start') }}</a><a :class="'btn ' + getStopButtonClass(pumpIndex)" v-on:click="stopFilling(pumpIndex)">Stop</a></div>
            <div class="flex-row wide" role="cell"><input type="text" class="form-control" readonly="true" v-model="total[pumpIndex]" /></div>
          </div>
        </div>
      </div>
      <editor-tabs :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <div id="all" class="tab-pane active" v-bind="tabPanel('all')" v-if="isTabActive('all')">
          <div v-if="transactions.length" class="table-container" role="table" :aria-label="_('Transactions')">
            <div class="flex-table row" role="rowgroup" v-for="transaction in transactions">
              <div class="flex-row first wide" role="cell">{{ DateTime.fromJSDate(transaction.date).toFormat(dateFormat + ' ' + timeFormat) }}</div>
              <div class="flex-row pump" role="cell"><span class="hidden-sm hidden-xs">{{ _('Pump') }} </span><span class="visible-sm visible-xs">{{ _('Pump').charAt(0) }} </span>{{ getDisplayedIndex(parseInt(transaction.pumpIndex, 10)) }}</div>
              <div class="flex-row" role="cell">{{ transaction.gasType }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.price, 3) }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.litres) }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.price * transaction.litres) }}</div>
              <div class="flex-row" role="cell">{{ _('POS') }} {{ transaction.pos }}</div>
              <div class="flex-row" role="cell" v-if="transaction.source === '1'"><a class="btn btn-success" v-on:click="addToReceipt(transaction)">{{ _('Add to receipt') }}</a></div>
              <div class="flex-row" role="cell" v-if="transaction.source === '0'"><a class="btn btn-default">{{ _('Paid') }}</a></div>
            </div>
          </div>
        </div>
        <div id="pos" class="tab-pane active" v-bind="tabPanel('pos')" v-if="isTabActive('pos')">
          <div v-if="transactions.length" class="table-container" role="table" :aria-label="_('Transactions')">
            <div class="flex-table row" role="rowgroup" v-for="transaction in transactions.filter(t => t.source === '1')">
              <div class="flex-row first wide" role="cell">{{ DateTime.fromJSDate(transaction.date).toFormat(dateFormat + ' ' + timeFormat) }}</div>
              <div class="flex-row pump" role="cell"><span class="hidden-sm hidden-xs">{{ _('Pump') }} </span><span class="visible-sm visible-xs">{{ _('Pump').charAt(0) }} </span>{{ getDisplayedIndex(parseInt(transaction.pumpIndex, 10)) }}</div>
              <div class="flex-row" role="cell">{{ transaction.gasType }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.price, 3) }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.litres) }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.price * transaction.litres) }}</div>
              <div class="flex-row" role="cell">{{ _('POS') }} {{ transaction.pos }}</div>
              <div class="flex-row" role="cell" v-if="transaction.source === '1'"><a class="btn btn-success" v-on:click="addToReceipt(transaction)">{{ _('Add to receipt') }}</a></div>
              <div class="flex-row" role="cell" v-if="transaction.source === '0'"><a class="btn btn-default">{{ _('Paid') }}</a></div>
            </div>
          </div>
        </div>
        <div id="other" class="tab-pane active" v-bind="tabPanel('other')" v-if="isTabActive('other')">
          <div v-if="transactions.length" class="table-container" role="table" :aria-label="_('Transactions')">
            <div class="flex-table row" role="rowgroup" v-for="transaction in transactions.filter(t => t.source === '0')">
              <div class="flex-row first wide" role="cell">{{ DateTime.fromJSDate(transaction.date).toFormat(dateFormat + ' ' + timeFormat) }}</div>
              <div class="flex-row pump" role="cell"><span class="hidden-sm hidden-xs">{{ _('Pump') }} </span><span class="visible-sm visible-xs">{{ _('Pump').charAt(0) }} </span>{{ getDisplayedIndex(parseInt(transaction.pumpIndex, 10)) }}</div>
              <div class="flex-row" role="cell">{{ transaction.gasType }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.price, 3) }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.litres) }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.price * transaction.litres) }}</div>
              <div class="flex-row" role="cell">{{ _('POS') }} {{ transaction.pos }}</div>
              <div class="flex-row" role="cell" v-if="transaction.source === '1'"><a class="btn btn-success" v-on:click="addToReceipt(transaction)">{{ _('Add to receipt') }}</a></div>
              <div class="flex-row" role="cell" v-if="transaction.source === '0'"><a class="btn btn-default">{{ _('Paid') }}</a></div>
            </div>
          </div>
        </div>
        <div id="processed" class="tab-pane active" v-bind="tabPanel('processed')" v-if="isTabActive('processed')">
          <div v-if="processedTransactions.length" class="table-container" role="table" :aria-label="_('Transactions')">
            <div class="flex-table row" role="rowgroup" v-for="transaction in processedTransactions.filter(t => t.source === '1')">
              <div class="flex-row first wide" role="cell">{{ DateTime.fromJSDate(transaction.date).toFormat(dateFormat + ' ' + timeFormat) }}</div>
              <div class="flex-row pump" role="cell"><span class="hidden-sm hidden-xs">{{ _('Pump') }} </span><span class="visible-sm visible-xs">{{ _('Pump').charAt(0) }} </span>{{ getDisplayedIndex(parseInt(transaction.pumpIndex, 10)) }}</div>
              <div class="flex-row" role="cell">{{ transaction.gasType }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.price, 3) }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.litres) }}</div>
              <div class="flex-row" role="cell">{{ $filters.num(transaction.price * transaction.litres) }}</div>
              <div class="flex-row" role="cell">{{ _('POS') }} {{ transaction.pos }}</div>
              <div class="flex-row" role="cell" v-if="transaction.source === '1'"><a class="btn btn-success" v-on:click="addToReceipt(transaction)">{{ _('Add to receipt') }}</a></div>
              <div class="flex-row" role="cell" v-if="transaction.source === '0'"><a class="btn btn-default">{{ _('Paid') }}</a></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="debugMode" class="gas-pump-debug-banner">
        <strong>GasPump debug mode</strong> — mock data from <code>lib/gaspump-debug.js</code>.
        Disable with <code>localStorage.removeItem('gasPumpDebug')</code>.
      </div>
      <pre v-if="debugMode" class="gas-pump-debug-json">{{ JSON.stringify(status, null, 2) }}</pre>
      <audio autoplay="true" loop="true" v-if="false && shouldPlayAlert" src="http://soundbible.com/mp3/sms-alert-1-daniel_simon.mp3"></audio>
    </div>
  </div>
</template>

<style scoped>
.pump-status {
  justify-content: center;
}

.pump-status-0 {
  background-color: green;
  color: white !important;
}
.pump-status-1 {
  background-color: yellow;
}
.pump-status-3 {
  background-color: blue;
  color: white !important;
}
.pump-status-5 {
  background-color: purple;
  color: white !important;
}
.pump-status-8, .pump-status-9 {
  background-color: red;
  color: white !important;
}

.gas-pump-debug-banner {
  margin: 1em 0;
  padding: 0.75em 1em;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  font-size: 13px;
}

.gas-pump-debug-json {
  margin: 1em 0;
  padding: 1em;
  max-height: 200px;
  overflow: auto;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 11px;
  white-space: pre-wrap;
}

div {
  box-sizing: border-box;
}

.table-container {
  display: block;
  margin: 2em auto;
  width: 100%;
}

.header > div {
  font-weight: bold;
}

.flex-table {
  display: flex;
  flex-flow: row wrap;
  transition: 0.5s;
  align-items: stretch;
  /*&:first-of-type .flex-row {
    color: white;
  }*/
}

.flex-row {
  width: calc(55% / 6);
  text-align: center;
  padding: 0.5em 0.5em;
  input.form-control {
    max-width: 100%;
  }
}
.wide {
  width: calc(44% / 3);
}

.rowspan {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
}

.column {
  display: flex;
  flex-flow: column wrap;
  width: 75%;
  padding: 0;
  .flex-row {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    padding: 0;
    border: 0;
  }
}

.flex-cell {
  width: calc(100% / 9);
  text-align: center;
  padding: 0.5em 0.5em;
}
.flex-table.row {
  margin-left: 0;
  margin-right: 0;
  border-bottom: 1px solid #d7d7d7;
  .flex-row {
    align-items: center;
    display: flex;
  }
}
.first {
  font-weight: bold;
}

@media all and (max-width: 767px) {
  .flex-row {
    width: calc(100% / 9);
    
   &.first {
     width: 100%;
   }
  }

  .column {
    width: 100%;
  }
}

@media all and (max-width: 430px) {
  
  .flex-table {
    .flex-row {
      border-bottom: 0;
    }
  }
  .header {
    .flex-row {
      border-bottom: solid 1px;
    }
  }
  
  .flex-row {
    width: 100%;
    
   &.first {
     width: 100%;
   }
  }

  .column {
    width: 100%;
  }

  .flex-cell {
    width: 100%; 
  }
}
.pump {
  white-space: nowrap;
  display: flex;
  flex-wrap: nowrap;
}
.flex-row.buttons {
  display: grid !important;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  a.btn {
    width: 100%;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>

<script>
import gaspump from '~/lib/gaspump'
import tabs from '~/lib/tabs'
import {
  isGasPumpDebugEnabled,
  getDebugGasPumpStatus,
  getDebugGasPumpTransactions,
  getDebugProcessedGasPumpTransactions
} from '~/lib/gaspump-debug'
import { mapGetters } from 'vuex'

export default {
  mixins: [gaspump, tabs],
  data() {
    return {
      activeTab: 'all',
      prevStatusStr: '',
      debugMode: false
    }
  },
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'all', label: this._('All') },
        { id: 'pos', label: this._('POS') },
        { id: 'other', label: this._('Other') },
        { id: 'processed', label: this._('Added to receipt') }
      ])
    },
    ...mapGetters(['dateFormat', 'timeFormat', 'numberFormat']),
  },
  watch: {
    pumpStatusStr (newStr) {
      if (newStr.includes('1')) {
        let ns = newStr.split(',')
        let ps = this.prevStatusStr.split(',')
        for (let i = 0; i < ns.length; i++) {
          if (ns[i] === '1' && ps[i] !== '1' && this.isPumpVisible(i + 1)) {
            this.notify('<speak>' + this._('Customer at pump %s.').replace('%s', '<say-as interpret-as="digits">' + this.getDisplayedIndex(i) + '</say-as>') + '</speak>')
          }
        }
      }
      this.prevStatusStr = newStr
    }
  },
  mounted () {
    if (isGasPumpDebugEnabled()) {
      this.debugMode = true
      this.status = getDebugGasPumpStatus()
      this.transactions = getDebugGasPumpTransactions()
      this.processedTransactions = getDebugProcessedGasPumpTransactions()
      this.prevStatusStr = this.pumpStatusStr
      return
    }
    if(!this.events) {
      let events = {}
      events['gasPumpStatus'] = (message) => {
        if (this.shopId == message.shopId) {
          this.status = message.data
          return
        }
      }
      /*
      events['gasPumpTransaction'] = (message) => {
        if (this.shopId == message.shopId) {
          if (typeof message.data === 'object') {
            this.transactions.unshift(message.data)
          } else {
            this.transactions.unshift(JSON.parse(message.data))
          }
        }
      }
      */
      events['gasUpdate'] = (message) => {
        if (this.shopId == message.shopId) {
          this.loadTransactions()
          this.loadProcessedTransactions()
        }
      }
      this.events = events
    }
    this.enableEventBus()
    this.requestGasPumpStatus()
    this.loadTransactions()
    this.loadProcessedTransactions()
    let ios = (/(ipod|iphone|ipad)/i).test(navigator.userAgent)
    if (ios) {
      this.showAudioButton = true
    }
  }
}

</script>
